import { LuminosityData } from 'verify/lib/utils/image';

/**
 * @returns true if the light conditions are too dim for a document id.
 */
export function isLowLightForDocument(luminosityData: LuminosityData | null): boolean {
  if (luminosityData == null) {
    return false;
  }
  if (luminosityData.rmsContrast === 0 && luminosityData.luminosity === 0) {
    // This is a perfectly black image. There is likely something wrong, eg. the camera was closed.
    return false;
  }
  // From tests, contrast plays a role but it's not dependable by itself. The contrast also varies greatly based
  // on the design of the ID and how close it's held. For instance, IDs printed colored cards have lower constrast
  // and an ID held close to the camera can take up then entire viewfinder, causing contrast numbers to drop.
  //
  // These values are decided based on testing. See
  // https://www.notion.so/withpersona/Web-Scanner-Evaluating-the-environment-68a1e497f8f24928ab14d94e9fcf1de1?pvs=4

  const lowContrast = luminosityData.rmsContrast < 0.2 || luminosityData.lowHighContrast < 0.2;
  const goodContrast = luminosityData.rmsContrast > 0.3 && luminosityData.lowHighContrast > 0.5;

  return (
    // Try to remove false positives (eg. dark background) by making sure contrast isn't too good either.
    (luminosityData.luminosity < 0.34 && !goodContrast) ||
    // Try to remove false positives (eg. light background) by making sure luminosity isn't too good either.
    (luminosityData.luminosity < 0.45 && lowContrast)
  );
}
